export const getBuildId = (): number => {
  const headComments = [...document.head.childNodes].filter(
    (node) => node.nodeType === document.COMMENT_NODE,
  ) as Comment[]

  const releaseComment = headComments.find((node) => /Git \w+, Build [0-9]+/.test(node.data))?.data.trim()

  // Extract the build ID as a number if `releaseComment` is found
  return releaseComment ? Number(releaseComment.match(/Build (\d+)/)?.[1]) : 0
}
